module.exports = __webpack_public_path__ + "img/contact.5782d94e.svg";